import { useCallback } from 'react';
import { useStoreInfo } from '@/hooks/useStoreInfo';
import { setCupon, useCuponGuardado } from '@/services/cupon';
import { setVendedor } from '@/services/vendedor';
import { calculaCupon, vendedorDelCupon, type LineaPedido } from '@/utils/pedido';

/** Cupón de vendedor del carrito: aplicarlo, quitarlo y calcular el descuento. */
export function useCupon() {
  const { vendedores, cupon: config } = useStoreInfo();
  const guardado = useCuponGuardado();

  /** Devuelve un mensaje de error, o null si quedó aplicado. */
  const aplicar = useCallback(
    (codigo: string): string | null => {
      const c = codigo.trim();
      if (!c) return 'Escribe el código del cupón';
      if (!config) return 'Por ahora no hay cupones activos';
      const v = vendedorDelCupon(c, vendedores);
      if (!v) return 'Ese cupón no existe';
      setCupon(c);
      // El cupón asigna el pedido a su vendedor, igual que su link
      setVendedor(v.codigo, 'link');
      return null;
    },
    [config, vendedores],
  );

  const quitar = useCallback(() => setCupon(null), []);

  const calcular = useCallback(
    (lineas: LineaPedido[]) => calculaCupon(guardado, vendedores, config, lineas),
    [guardado, vendedores, config],
  );

  return { activo: !!config, config, codigo: guardado, aplicar, quitar, calcular };
}
